import TerminalBody from './TerminalBody'

export default TerminalBody
